<div [ngStyle]="{ height: height}">
  <span class="font-bold text-xl">Es ist ein Fehler aufgetreten</span>
  <p class="mt-2 mb-0">Grafik konnte nicht geladen werden. Bitte versuchen Sie es erneut.</p>
  <p class="mt-0">Bitte versuchen Sie es später erneut. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an <a href="mailto:support@standortmonitor.net">support&#64;standortmonitor.net</a></p>
</div>
